import React, { Component } from 'react';
import AuthService from '../AuthService';
import constants from '../../config';
import { resolveCardImage } from '../../utils/resolveImage';
import { formatDate } from './shared/formatters';

var Auth = new AuthService();

class AdminListings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listings: [],
      pagination: { page: 1, limit: 25, total: 0, pages: 0 },
      loading: true,
      search: '',
      filterStatus: '',
      filterCategory: '',
      sortBy: 'newest',
      priceMin: '',
      priceMax: '',
      dateFrom: '',
      dateTo: '',
      searchTimer: null,
      editingId: null,
      editTitle: '',
      editPrice: '',
      editCategory: '',
      editShipping: '',
      editLoading: false,
      expandedId: null,
    };
    this.fetchListings = this.fetchListings.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
  }

  componentDidMount() {
    this.fetchListings(1);
  }

  fetchListings(page) {
    var self = this;
    self.setState({ loading: true });
    var params = new URLSearchParams();
    params.append('page', page || 1);
    params.append('limit', 25);
    if (self.state.search) params.append('search', self.state.search);
    if (self.state.filterStatus) params.append('status', self.state.filterStatus);
    if (self.state.filterCategory) params.append('category', self.state.filterCategory);
    if (self.state.sortBy) params.append('sortBy', self.state.sortBy);
    if (self.state.priceMin) params.append('priceMin', self.state.priceMin);
    if (self.state.priceMax) params.append('priceMax', self.state.priceMax);
    if (self.state.dateFrom) params.append('dateFrom', self.state.dateFrom);
    if (self.state.dateTo) params.append('dateTo', self.state.dateTo);

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/listings?' + params.toString())
      .then(function(data) {
        self.setState({ listings: data.listings || [], pagination: data.pagination || {}, loading: false });
      })
      .catch(function(err) {
        console.log('Failed to fetch listings:', err);
        self.setState({ loading: false });
      });
  }

  handleSearchChange(e) {
    var self = this;
    var value = e.target.value;
    if (self.state.searchTimer) clearTimeout(self.state.searchTimer);
    self.setState({
      search: value,
      searchTimer: setTimeout(function() { self.fetchListings(1); }, 400),
    });
  }

  handleExport() {
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/listings/export', { rawResponse: true })
      .then(function(res) {
        return res.blob ? res.blob() : res.text();
      })
      .then(function(data) {
        var blob = data instanceof Blob ? data : new Blob([data], { type: 'text/csv' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'listings-' + new Date().toISOString().split('T')[0] + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .catch(function(err) {
        console.log('Failed to export listings:', err);
      });
  }

  handleSaveEdit() {
    var self = this;
    self.setState({ editLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/admin/listings/' + self.state.editingId, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title: self.state.editTitle,
        price: parseFloat(self.state.editPrice),
        category: self.state.editCategory,
        shippingCost: parseFloat(self.state.editShipping),
      }),
    })
      .then(function() {
        self.setState({ editingId: null, editLoading: false });
        self.fetchListings(self.state.pagination.page);
      })
      .catch(function(err) {
        console.log('Failed to update listing:', err);
        self.setState({ editLoading: false });
      });
  }

  render() {
    var self = this;
    var listings = this.state.listings;
    var pagination = this.state.pagination;
    var onConfirm = this.props.onConfirm;
    var onOpenUserModal = this.props.onOpenUserModal;
    var hasFilters = this.state.search || this.state.filterStatus || this.state.filterCategory || this.state.priceMin || this.state.priceMax || this.state.dateFrom || this.state.dateTo;
    var isDark = document.documentElement.classList.contains('tw-dark');

    return (
      <div>
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
          <div>
            <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Listings</h2>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">{pagination.total || 0} total listings</p>
          </div>
          <button
            className="tw-text-xs tw-px-4 tw-py-2.5 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
            style={{ backgroundColor: '#D4A843' }}
            onClick={this.handleExport}
          >
            <i className="fa fa-download tw-mr-1" />Export CSV
          </button>
        </div>

        {/* Filters */}
        <div className="tw-rounded-xl tw-p-4 tw-mb-4" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
          <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center">
            <div className="tw-relative tw-flex-1" style={{ minWidth: 200 }}>
              <i className="fa fa-search tw-absolute tw-left-3 tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-50%)', fontSize: 12 }} />
              <input
                type="text"
                className="tw-w-full tw-pl-8 tw-pr-3 tw-py-2.5 tw-text-sm tw-rounded-lg tw-border tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
                placeholder="Search by title..."
                value={this.state.search}
                onChange={this.handleSearchChange}
              />
            </div>
            <select
              className="tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.filterStatus}
              onChange={function(e) { self.setState({ filterStatus: e.target.value }, function() { self.fetchListings(1); }); }}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="sold">Sold</option>
              <option value="deactivated">Deactivated</option>
              <option value="reported">Reported</option>
            </select>
            <select
              className="tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.sortBy}
              onChange={function(e) { self.setState({ sortBy: e.target.value }, function() { self.fetchListings(1); }); }}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="price_asc">Price: Low to High</option>
              <option value="price_desc">Price: High to Low</option>
              <option value="reported">Most Reported</option>
            </select>
            <input
              type="number"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={{ width: 90 }}
              placeholder="Min $"
              value={this.state.priceMin}
              onChange={function(e) { self.setState({ priceMin: e.target.value }, function() { self.fetchListings(1); }); }}
            />
            <input
              type="number"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={{ width: 90 }}
              placeholder="Max $"
              value={this.state.priceMax}
              onChange={function(e) { self.setState({ priceMax: e.target.value }, function() { self.fetchListings(1); }); }}
            />
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.dateFrom}
              onChange={function(e) { self.setState({ dateFrom: e.target.value }, function() { self.fetchListings(1); }); }}
            />
            <input
              type="date"
              className="tw-border tw-rounded-lg tw-px-3 tw-py-2.5 tw-text-sm tw-outline-none focus:tw-border-[#D4A843] tw-bg-white dark:tw-bg-[#141414] tw-text-[#1a1a1a] dark:tw-text-white dark:tw-border-[#555]"
              style={isDark ? { colorScheme: 'dark' } : {}}
              value={this.state.dateTo}
              onChange={function(e) { self.setState({ dateTo: e.target.value }, function() { self.fetchListings(1); }); }}
            />
            {hasFilters && (
              <button
                className="tw-text-xs tw-px-3 tw-py-2.5 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer hover:tw-bg-[#f5f5f5]"
                onClick={function() { self.setState({ search: '', filterStatus: '', filterCategory: '', sortBy: 'newest', priceMin: '', priceMax: '', dateFrom: '', dateTo: '' }, function() { self.fetchListings(1); }); }}
              >
                <i className="fa fa-times tw-mr-1" />Clear
              </button>
            )}
          </div>
        </div>

        {/* Loading */}
        {this.state.loading && (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading listings...</span>
            </div>
          </div>
        )}

        {/* Table */}
        {!this.state.loading && (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-overflow-x-auto">
              <table className="tw-w-full tw-text-sm" style={{ minWidth: '600px' }}>
                <thead>
                  <tr style={{ backgroundColor: isDark ? '#111' : '#fafafa', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Listing</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Price</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Seller</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Status</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Category</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden lg:tw-table-cell">Reports</th>
                    <th className="tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider tw-hidden md:tw-table-cell">Listed</th>
                    <th className="tw-px-4 tw-py-3 tw-text-right tw-text-xs tw-font-semibold tw-text-[#888] tw-uppercase tw-tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {listings.map(function(listing) {
                    var isActive = listing.active !== false && !listing.sold;
                    var isSold = listing.sold;
                    var isDeactivated = listing.active === false;
                    var statusLabel = isSold ? 'Sold' : isDeactivated ? 'Deactivated' : 'Active';
                    var statusColor = isSold ? '#6B7280' : isDeactivated ? '#f59e0b' : '#10B981';
                    var image = resolveCardImage(listing.cardImage) || (listing.images && listing.images[0] ? resolveCardImage(listing.images[0]) : null);
                    var seller = listing.user || {};
                    var isEditing = self.state.editingId === listing._id;
                    var isExpanded = self.state.expandedId === listing._id;

                    return (
                      <React.Fragment key={listing._id}>
                        <tr className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#f9f9f9] dark:hover:tw-bg-[#151515] tw-transition-colors">
                          <td className="tw-px-4 tw-py-3.5">
                            <div className="tw-flex tw-items-center tw-gap-2.5">
                              {image ? (
                                <img src={image} alt="" className="tw-w-10 tw-h-10 tw-rounded-lg tw-object-cover tw-flex-shrink-0" />
                              ) : (
                                <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#f0f0f0' }}>
                                  <i className="fa fa-image tw-text-xs tw-text-[#ccc]" />
                                </div>
                              )}
                              <div className="tw-min-w-0">
                                <div className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-truncate" style={{ maxWidth: 200 }}>{listing.title}</div>
                                {listing.condition && <div className="tw-text-[10px] tw-text-[#999]">{listing.condition}</div>}
                              </div>
                            </div>
                          </td>
                          <td className="tw-px-4 tw-py-3.5">
                            <span className="tw-text-sm tw-font-semibold" style={{ color: '#D4A843' }}>${(listing.price || 0).toFixed(2)}</span>
                            {listing.shippingCost > 0 && (
                              <div className="tw-text-[10px] tw-text-[#999]">+${listing.shippingCost.toFixed(2)} ship</div>
                            )}
                            {listing.shippingCost === 0 && (
                              <div className="tw-text-[10px]" style={{ color: '#10B981' }}>Free ship</div>
                            )}
                          </td>
                          <td className="tw-px-4 tw-py-3.5 tw-hidden md:tw-table-cell">
                            <span
                              className="tw-text-sm tw-font-medium tw-cursor-pointer hover:tw-underline"
                              style={{ color: '#D4A843' }}
                              onClick={function(e) { e.stopPropagation(); if (onOpenUserModal && seller._id) onOpenUserModal(seller._id); }}
                            >
                              {seller.userName || 'Unknown'}
                            </span>
                          </td>
                          <td className="tw-px-4 tw-py-3.5">
                            <span className="tw-text-xs tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-text-white" style={{ backgroundColor: statusColor }}>{statusLabel}</span>
                          </td>
                          <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-hidden lg:tw-table-cell">{listing.category || '—'}</td>
                          <td className="tw-px-4 tw-py-3.5 tw-hidden lg:tw-table-cell">
                            {listing.reportedCount > 0 ? (
                              <span className="tw-text-xs tw-font-bold" style={{ color: '#EF4444' }}>
                                <i className="fa fa-flag tw-mr-1" />{listing.reportedCount}
                              </span>
                            ) : (
                              <span className="tw-text-xs tw-text-[#999]">0</span>
                            )}
                          </td>
                          <td className="tw-px-4 tw-py-3.5 tw-text-xs tw-text-[#999] tw-hidden md:tw-table-cell">{listing.createdAt ? formatDate(listing.createdAt) : '—'}</td>
                          <td className="tw-px-4 tw-py-3.5 tw-text-right">
                            <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
                              <button
                                className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#3B82F6]"
                                title="Edit"
                                onClick={function() {
                                  self.setState({
                                    expandedId: isExpanded ? null : listing._id,
                                    editingId: null,
                                  });
                                }}
                              >
                                <i className={'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down')} style={{ fontSize: 11 }} />
                              </button>
                              {isActive && (
                                <button
                                  className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#f59e0b]"
                                  title="Deactivate"
                                  onClick={function() {
                                    if (onConfirm) onConfirm({
                                      type: 'deactivateListing',
                                      title: 'Deactivate Listing',
                                      message: 'Deactivate "' + listing.title + '"? It will be hidden from the marketplace but not deleted. No strike will be added.',
                                      btnColor: '#f59e0b',
                                      btnIcon: 'fa-eye-slash',
                                      onConfirm: function() {
                                        return Auth.fetch(constants.DOMAIN + '/api/v1/admin/listings/' + listing._id + '/deactivate', { method: 'POST' })
                                          .then(function() { self.fetchListings(self.state.pagination.page); });
                                      },
                                    });
                                  }}
                                >
                                  <i className="fa fa-eye-slash" style={{ fontSize: 11 }} />
                                </button>
                              )}
                              {isDeactivated && (
                                <button
                                  className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#10B981]"
                                  title="Reactivate"
                                  onClick={function() {
                                    if (onConfirm) onConfirm({
                                      type: 'reactivateListing',
                                      title: 'Reactivate Listing',
                                      message: 'Reactivate "' + listing.title + '"? It will be visible on the marketplace again.',
                                      btnColor: '#10B981',
                                      btnIcon: 'fa-eye',
                                      onConfirm: function() {
                                        return Auth.fetch(constants.DOMAIN + '/api/v1/admin/listings/' + listing._id + '/reactivate', { method: 'POST' })
                                          .then(function() { self.fetchListings(self.state.pagination.page); });
                                      },
                                    });
                                  }}
                                >
                                  <i className="fa fa-eye" style={{ fontSize: 11 }} />
                                </button>
                              )}
                              {!isSold && (
                                <button
                                  className="tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-[#999] hover:tw-text-[#EF4444]"
                                  title="Remove (permanent)"
                                  onClick={function() {
                                    if (onConfirm) onConfirm({
                                      type: 'removeListing',
                                      title: 'Remove Listing',
                                      message: 'Permanently delete "' + listing.title + '"? This will also add a strike to the seller. This cannot be undone.',
                                      btnColor: '#EF4444',
                                      btnIcon: 'fa-ban',
                                      onConfirm: function() {
                                        return Auth.fetch(constants.DOMAIN + '/api/v1/admin/reported/' + listing._id + '/remove', { method: 'POST' })
                                          .then(function() { self.fetchListings(self.state.pagination.page); });
                                      },
                                    });
                                  }}
                                >
                                  <i className="fa fa-ban" style={{ fontSize: 11 }} />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                        {/* Expanded Edit Row */}
                        {isExpanded && (
                          <tr className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222]">
                            <td colSpan="8" className="tw-px-4 tw-py-4" style={{ backgroundColor: isDark ? '#111' : '#fafafa' }}>
                              {!isEditing ? (
                                <div>
                                  <div className="tw-flex tw-items-start tw-gap-4 tw-flex-wrap">
                                    {image && <img src={image} alt="" className="tw-w-24 tw-h-24 tw-rounded-lg tw-object-cover" />}
                                    <div className="tw-flex-1" style={{ minWidth: 200 }}>
                                      <h4 className="tw-text-sm tw-font-semibold tw-m-0 tw-mb-2" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>{listing.title}</h4>
                                      <div className="tw-grid tw-gap-1.5" style={{ gridTemplateColumns: 'auto 1fr', fontSize: 13, color: isDark ? '#ccc' : '#333' }}>
                                        <span className="tw-text-[#999]">Price:</span>
                                        <span className="tw-font-medium" style={{ color: '#D4A843' }}>${(listing.price || 0).toFixed(2)}</span>
                                        <span className="tw-text-[#999]">Shipping:</span>
                                        <span>${(listing.shippingCost || 0).toFixed(2)}</span>
                                        <span className="tw-text-[#999]">Category:</span>
                                        <span>{listing.category || '—'}</span>
                                        <span className="tw-text-[#999]">Quantity:</span>
                                        <span>{listing.quantity || 1}</span>
                                        <span className="tw-text-[#999]">Condition:</span>
                                        <span>{listing.condition || '—'}</span>
                                        <span className="tw-text-[#999]">Seller:</span>
                                        <span
                                          className="tw-cursor-pointer hover:tw-underline"
                                          style={{ color: '#D4A843' }}
                                          onClick={function() { if (onOpenUserModal && seller._id) onOpenUserModal(seller._id); }}
                                        >
                                          {seller.userName || 'Unknown'}
                                        </span>
                                        <span className="tw-text-[#999]">Listed:</span>
                                        <span>{listing.createdAt ? formatDate(listing.createdAt) : '—'}</span>
                                      </div>
                                      {listing.text && (
                                        <div className="tw-mt-2">
                                          <span className="tw-text-xs tw-text-[#999]">Description:</span>
                                          <p className="tw-text-xs tw-m-0 tw-mt-0.5" style={{ color: isDark ? '#aaa' : '#666' }}>{listing.text}</p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {!isSold && (
                                    <button
                                      className="tw-mt-3 tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                                      style={{ backgroundColor: '#3B82F6' }}
                                      onClick={function() {
                                        self.setState({
                                          editingId: listing._id,
                                          editTitle: listing.title || '',
                                          editPrice: String(listing.price || ''),
                                          editCategory: listing.category || '',
                                          editShipping: String(listing.shippingCost || 0),
                                        });
                                      }}
                                    >
                                      <i className="fa fa-pencil tw-mr-1" />Edit Listing
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <div>
                                  <h4 className="tw-text-sm tw-font-semibold tw-m-0 tw-mb-3" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>
                                    <i className="fa fa-pencil tw-mr-1" style={{ color: '#3B82F6' }} />Edit Listing
                                  </h4>
                                  <div className="tw-grid tw-gap-3" style={{ gridTemplateColumns: '1fr 1fr', maxWidth: 400 }}>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                      <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Title</label>
                                      <input
                                        type="text"
                                        className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                                        value={self.state.editTitle}
                                        onChange={function(e) { self.setState({ editTitle: e.target.value }); }}
                                      />
                                    </div>
                                    <div>
                                      <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Price ($)</label>
                                      <input
                                        type="number"
                                        step="0.01"
                                        className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                                        value={self.state.editPrice}
                                        onChange={function(e) { self.setState({ editPrice: e.target.value }); }}
                                      />
                                    </div>
                                    <div>
                                      <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Shipping ($)</label>
                                      <input
                                        type="number"
                                        step="0.01"
                                        className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                                        value={self.state.editShipping}
                                        onChange={function(e) { self.setState({ editShipping: e.target.value }); }}
                                      />
                                    </div>
                                    <div style={{ gridColumn: '1 / -1' }}>
                                      <label className="tw-text-xs tw-text-[#666] tw-block tw-mb-1">Category</label>
                                      <input
                                        type="text"
                                        className="tw-w-full tw-px-3 tw-py-2 tw-text-sm tw-rounded-lg tw-border tw-bg-white dark:tw-bg-[#111] tw-text-[#1a1a1a] dark:tw-text-white tw-border-[#d0d0d0] dark:tw-border-[#555]"
                                        value={self.state.editCategory}
                                        onChange={function(e) { self.setState({ editCategory: e.target.value }); }}
                                      />
                                    </div>
                                  </div>
                                  <div className="tw-flex tw-gap-2 tw-mt-3">
                                    <button
                                      className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-text-white tw-border-0 tw-cursor-pointer hover:tw-opacity-90"
                                      style={{ backgroundColor: '#10B981' }}
                                      disabled={self.state.editLoading}
                                      onClick={self.handleSaveEdit}
                                    >
                                      {self.state.editLoading ? <i className="fa fa-spinner fa-spin" /> : 'Save Changes'}
                                    </button>
                                    <button
                                      className="tw-text-xs tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-border tw-bg-transparent tw-cursor-pointer"
                                      style={isDark ? { borderColor: '#333', color: '#aaa' } : { borderColor: '#ddd', color: '#666' }}
                                      onClick={function() { self.setState({ editingId: null }); }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                  {listings.length === 0 && (
                    <tr><td colSpan="8" className="tw-px-4 tw-py-12 tw-text-center tw-text-[#999]">
                      <i className="fa fa-tag tw-text-3xl tw-mb-2" style={{ display: 'block' }} />No listings found
                    </td></tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3" style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                <span className="tw-text-xs tw-text-[#999]">
                  Showing {((pagination.page - 1) * pagination.limit) + 1}–{Math.min(pagination.page * pagination.limit, pagination.total)} of {pagination.total}
                </span>
                <div className="tw-flex tw-gap-1">
                  <button
                    className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                    disabled={pagination.page <= 1}
                    onClick={function() { self.fetchListings(pagination.page - 1); }}
                  >Prev</button>
                  <button
                    className="tw-px-3 tw-py-1.5 tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-rounded-lg tw-bg-transparent tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40"
                    disabled={pagination.page >= pagination.pages}
                    onClick={function() { self.fetchListings(pagination.page + 1); }}
                  >Next</button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminListings;
